import { createGlobalStyle } from 'styled-components';


export const blueDarkColor = '#0254E6';
export const blueMediumColor = '#3076E7';

export const redMediumColor = '#D85529';

export const beigeColor = '#EDEAD2';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Tahoma, Verdana, Segoe, sans-serif;
	font-size: 1.5vmin;
  }`;
